import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { Spin } from 'antd'
import App from 'components/app/App'
import AiLoader from 'components/ai-loader/AiLoader'
import AppRoutes from './routes'
import { store } from './store'

//import reportWebVitals from './reportWebVitals'
import './index.css'

Spin.setDefaultIndicator(<AiLoader />)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <App>
      <AppRoutes />
    </App>
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
